import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  height: number
}

export default createStyles((theme, _params: StylesParams) => {
  const dark = theme.colorScheme === 'dark'

  const { height } = _params

  return {
    main: {
      backgroundColor: dark ? theme.colors.dark[7] : theme.colors.gray[0],
      borderTop: `${rem(1)} solid ${dark ? theme.colors.dark[5] : theme.colors.gray[2]}`,
      minHeight: rem(height),
    },

    content: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      padding: '1rem',
    },
  }
})
